import { Container, Row } from "reactstrap";
import { FormWidgetsTitle, SwitchTitle } from "../../../../../constants";
import CustomSwitch from "./CustomSwitch";
import DisabledOutlineSwitch from './DisabledOutlineSwitch';
import IconUncheckedBorderSwitch from './IconUncheckedBorderSwitch';
import SwitchSizingIcons from './SwitchSizingIcons';
import VariationOfSwitches from './VariationOfSwitches';
import Breadcrumbs from "../../../../../coreComponents/breadcrumbs";

const SwitchContainer = () => {
  return (
    <>
    <Breadcrumbs mainTitle={SwitchTitle} parent={FormWidgetsTitle}/>
      <Container fluid>
        <Row>
          <CustomSwitch />
          <IconUncheckedBorderSwitch />
          <DisabledOutlineSwitch />
          <VariationOfSwitches />
          <SwitchSizingIcons />
        </Row>
      </Container>
    </>
  );
};
export default SwitchContainer;
